import React, { createContext } from 'react';

/**
 * 設定情報インターフェース
 */
export interface Settings {
  headerHeight: number;
}

/**
 * 設定情報 デフォルト設定
 */
const defaultSettings: Settings = {
  headerHeight: 52,
};

/**
 * 設定情報 コンテキスト作成
 */
export const SettingContext = createContext<Settings>(defaultSettings);

/**
 * 設定情報プロバイダ
 * @param children
 * @constructor
 */
export const SettingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // SettingContext.Providerのラッパー
  return <SettingContext.Provider value={defaultSettings}>{children}</SettingContext.Provider>;
};
